<div class="mat-dialog-title" i18n>Bulk Change</div>
<p>The changes made below will be applied to the <b>{{items.length}}</b> items matched in the search criteria.</p>
<div>
  <form #form="ngForm" (ngSubmit)="bulkUpdate(form)">
    <div class="card-body">
      <div class="form-group form-inline">
        <label class="col-sm-4" for="priceAdjustmentType" i18n>Adjust pricing by?</label>
        <div class="col-sm-8">
          <mat-radio-group name="priceAdjustmentType" id="priceAdjustmentType" required ngModel #priceAdjustmentType="ngModel">
            <mat-radio-button class="mr-3" [value]="1" i18n>Price Per Square Foot</mat-radio-button>
            <mat-radio-button [value]="2" i18n>Percentage</mat-radio-button>
          </mat-radio-group>
          <div class="info-icon" i18n-matTooltip
               matTooltip="Percentage will increase the price of each item by the chosen percentage.  If a product has no price, a percentage adjustment will have no effect. Price per square foot is a flat amount that will be set on each item."></div>
          <div [hidden]="!form.submitted || priceAdjustmentType.valid"
               class="alert alert-danger" i18n>Price adjustment type is required</div>
        </div>
      </div>
      <div class="form-group form-inline">
        <label class="col-sm-4  col-form-label" for="priceAdjustmentAmount" i18n>Adjustment Amount</label>
        <div class="col-sm-8">
          <input type="number" step="0.01" min="0" id="priceAdjustmentAmount" name="priceAdjustmentAmount" class="form-control" ngModel required #priceAdjustmentAmount>
          <div [hidden]="!form.submitted || priceAdjustmentType.valid"
               class="alert alert-danger" i18n>Adjustment Amount is required</div>
        </div>
      </div>
    </div>
    <div class="mat-dialog-actions float-right">
      <button type="submit" value="submit" name="submit" id="submit" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
      <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
    </div>
  </form>
</div>
